import { useMemo } from 'react';

import { useMultiFlightMap } from '../../../MultiFlightMap.context';
import { CartographyLevelLayer } from './CartographyLevelLayer';

type Props = {
  mapId: string;
};

export function CartographyLevelsManager({ mapId }: Props) {
  const { countries, locations, temporaryLocation } = useMultiFlightMap();

  const locationsByCountryAndLevel = useMemo(() => {
    return [...locations, ...(temporaryLocation ? [temporaryLocation] : [])].reduce(
      (acc, location) => {
        const level = location.cartographyLevel;
        const country = location.country || countries[0];
        if (!level || !country) {
          return acc;
        }
        const key = `${country}|${level}`;
        if (!acc[key]) {
          acc[key] = { cartographyLevel: level, country, locations: [] };
        }
        acc[key].locations.push(location);
        return acc;
      },
      {} as Record<string, { cartographyLevel: string; country: string; locations: typeof locations }>
    );
  }, [countries, locations, temporaryLocation]);

  return (
    <>
      {Object.entries(locationsByCountryAndLevel).map(
        ([key, { cartographyLevel, country, locations: levelLocations }]) => (
          <CartographyLevelLayer
            cartographyLevel={cartographyLevel}
            country={country}
            key={`${mapId}-${key}`}
            locations={levelLocations}
            mapId={mapId}
          />
        )
      )}
    </>
  );
}
